export const UI_LANGUAGE_STORAGE_KEY = 'geeklly.uiLanguage';

export const SUPPORTED_UI_LANGUAGES = Object.freeze([
  { code: 'en', flag: '🇬🇧', label: 'English', nativeName: 'English', shortLabel: 'EN', dir: 'ltr' },
  { code: 'ar', flag: '🇸🇦', label: 'Arabic', nativeName: 'عربي', shortLabel: 'AR', dir: 'rtl' },
  { code: 'es', flag: '🇪🇸', label: 'Spanish', nativeName: 'Español', shortLabel: 'ES', dir: 'ltr' },
  { code: 'pt', flag: '🇵🇹', label: 'Portuguese', nativeName: 'Português', shortLabel: 'PT', dir: 'ltr' },
  { code: 'my', flag: '🇲🇲', label: 'Burmese', nativeName: 'မြန်မာဘာသာ', shortLabel: 'MY', dir: 'ltr' },
  { code: 'th', flag: '🇹🇭', label: 'Thai', nativeName: 'ภาษาไทย', shortLabel: 'TH', dir: 'ltr' },
  { code: 'zh-Hant', flag: '🇹🇼', label: 'Traditional Chinese', nativeName: '繁體中文', shortLabel: '繁', dir: 'ltr' },
  { code: 'zh-Hans', flag: '🇨🇳', label: 'Simplified Chinese', nativeName: '简体中文', shortLabel: '简', dir: 'ltr' },
  { code: 'it', flag: '🇮🇹', label: 'Italian', nativeName: 'Italiano', shortLabel: 'IT', dir: 'ltr' },
  { code: 'de', flag: '🇩🇪', label: 'German', nativeName: 'Deutsch', shortLabel: 'DE', dir: 'ltr' },
  { code: 'ru', flag: '🇷🇺', label: 'Russian', nativeName: 'Русский', shortLabel: 'RU', dir: 'ltr' },
  { code: 'fr', flag: '🇫🇷', label: 'French', nativeName: 'Français', shortLabel: 'FR', dir: 'ltr' },
  { code: 'ja', flag: '🇯🇵', label: 'Japanese', nativeName: '日本語', shortLabel: 'JP', dir: 'ltr' },
  { code: 'id', flag: '🇮🇩', label: 'Indonesian', nativeName: 'Bahasa Indonesia', shortLabel: 'ID', dir: 'ltr' },
  { code: 'tr', flag: '🇹🇷', label: 'Turkish', nativeName: 'Türkçe', shortLabel: 'TR', dir: 'ltr' },
  { code: 'ko', flag: '🇰🇷', label: 'Korean', nativeName: '한국어', shortLabel: 'KO', dir: 'ltr' },
  { code: 'vi', flag: '🇻🇳', label: 'Vietnamese', nativeName: 'Tiếng Việt', shortLabel: 'VI', dir: 'ltr' },
  { code: 'he', flag: '🇮🇱', label: 'Hebrew', nativeName: 'עברית', shortLabel: 'HE', dir: 'rtl' }
]);

export const REQUIRED_UI_I18N_KEYS = Object.freeze([
  'language.label',
  'language.current',
  'login.brand',
  'login.logoAlt',
  'login.title',
  'login.subtitle',
  'login.account',
  'login.password',
  'login.accountPlaceholder',
  'login.passwordPlaceholder',
  'login.keepLoggedIn',
  'login.forgotPassword',
  'login.submit',
  'login.busy',
  'login.divider',
  'login.methodsLabel',
  'login.methodPhone',
  'login.methodFacebook',
  'login.methodGoogle',
  'login.methodWeChat',
  'login.methodSso',
  'login.noAccount',
  'login.contactUs',
  'login.providerUnavailable',
  'login.providerInvalidUrl',
  'login.passwordRecoveryHint',
  'login.errorMissing',
  'login.errorTurnstile',
  'login.errorInvalid',
  'login.turnstileRequired',
  'login.turnstileComplete',
  'login.turnstileExpired',
  'login.turnstileLoadFailed',
  'login.turnstileUnavailable',
  'login.heroTitle',
  'login.heroSubtitle',
  'nav.home',
  'nav.dashboard',
  'nav.inquiries',
  'nav.leadFilter',
  'nav.customerPool',
  'nav.chat',
  'nav.waBinding',
  'nav.piCenter',
  'nav.followupTasks',
  'nav.marketing',
  'nav.businessReview',
  'nav.resendSettings',
  'topbar.notifications',
  'topbar.help',
  'topbar.online',
  'profile.view',
  'profile.viewDesc',
  'profile.avatar',
  'profile.avatarDesc',
  'profile.security',
  'profile.securityDesc',
  'profile.theme',
  'profile.themeDesc',
  'profile.logout',
  'profile.logoutDesc',
  'dashboard.todayData',
  'dashboard.settings',
  'dashboard.chooseCards',
  'dashboard.restoreAll',
  'dashboard.plan',
  'dashboard.whatsappPrivate',
  'dashboard.validUntil',
  'dashboard.dealOpportunities',
  'dashboard.dealSubtitle',
  'dashboard.piRadar',
  'dashboard.piRadarSubtitle',
  'dashboard.searchPlaceholder',
  'module.leadFilter.title',
  'module.leadFilter.subtitle',
  'module.leadFilter.scanAll',
  'module.inquiries.title',
  'module.inquiries.resultCount',
  'module.customerPool.kicker',
  'module.customerPool.title',
  'module.customerPool.subtitle',
  'module.customerPool.addCustomer',
  'module.customerPool.manualAdd',
  'module.customerPool.bulkImport',
  'module.customerPool.total',
  'module.customerPool.totalHint',
  'module.customerPool.visible',
  'module.customerPool.visibleHint',
  'module.customerPool.tierA',
  'module.customerPool.tierAHint',
  'module.customerPool.tierB',
  'module.customerPool.tierBHint',
  'module.customerPool.tierC',
  'module.customerPool.tierCHint',
  'module.customerPool.tierD',
  'module.customerPool.tierDHint',
  'module.customerPool.piOpened',
  'module.customerPool.piOpenedHint',
  'module.customerPool.unassigned',
  'module.customerPool.unassignedHint',
  'module.customerPool.filterKeyword',
  'module.customerPool.searchPlaceholder',
  'module.customerPool.filterTier',
  'module.customerPool.allTiers',
  'module.customerPool.filterStage',
  'module.customerPool.allStages',
  'module.customerPool.filterOwner',
  'module.customerPool.allOwners',
  'module.customerPool.filterCountry',
  'module.customerPool.moreFilters',
  'module.customerPool.piOpenedFilter',
  'module.customerPool.all',
  'module.customerPool.opened',
  'module.customerPool.unopened',
  'module.customerPool.filterSource',
  'module.customerPool.allSources',
  'module.customerPool.scoreRange',
  'module.customerPool.allScores',
  'module.customerPool.sleeping',
  'module.customerPool.onlySleeping',
  'module.customerPool.excludeSleeping',
  'module.customerPool.pendingTask',
  'module.customerPool.hasTask',
  'module.customerPool.noTask',
  'module.customerPool.selectedCount',
  'module.customerPool.chooseOwner',
  'module.customerPool.assign',
  'module.customerPool.changeTier',
  'module.customerPool.updateTier',
  'module.customerPool.createTasks',
  'module.customerPool.clear',
  'module.customerPool.scoreUnit',
  'module.customerPool.ownerPrefix',
  'module.customerPool.unknownCustomer',
  'module.customerPool.unknownCountry',
  'module.customerPool.piOpenCount',
  'module.customerPool.sourcePrefix',
  'module.customerPool.needLabel',
  'module.customerPool.lastMessage',
  'module.customerPool.nextStep',
  'module.customerPool.customActionPlaceholder',
  'module.customerPool.createAction',
  'module.customerPool.goChat',
  'module.customerPool.editProfile',
  'module.customerPool.emptyFiltered',
  'module.chat.selectAccount',
  'module.chat.selectConversation',
  'module.chat.searchPlaceholder',
  'module.chat.realtimeTranslate',
  'module.chat.aiAssistant',
  'module.chat.templates',
  'module.chat.smartPi',
  'module.waBinding.title',
  'module.piCenter.title',
  'module.followup.title',
  'module.marketing.title',
  'module.businessReview.title',
  'module.resend.title',
  'common.save',
  'common.cancel',
  'common.close',
  'common.delete',
  'common.edit',
  'common.back',
  'common.return',
  'common.search',
  'common.export',
  'common.reset',
  'common.settings',
  'common.allCountries',
  'common.allStatuses',
  'common.startDate',
  'common.endDate',
  'common.status',
  'common.country',
  'common.customer',
  'common.product',
  'common.none',
  'common.noData',
  'status.precise',
  'status.invalid',
  'status.review',
  'status.consulting',
  'status.quoted',
  'status.piSent',
  'status.piOpened',
  'status.pendingPayment',
  'status.completed'
]);

const zhHans = {
  'language.label': 'Language',
  'language.current': '语言',
  'login.brand': '即客来智能私域获客系统',
  'login.logoAlt': '即客来 Geeklly Logo',
  'brand.short': '即客来',
  'brand.system': '智能私域获客系统',
  'login.title': '欢迎登录',
  'login.subtitle': '登录即客来商家工作台。',
  'login.account': '账号',
  'login.password': '密码',
  'login.accountPlaceholder': '邮箱 / 账号 / 手机号',
  'login.passwordPlaceholder': '密码',
  'login.keepLoggedIn': '保持登录状态',
  'login.forgotPassword': '忘记密码',
  'login.submit': '登录',
  'login.busy': '登录中...',
  'login.divider': '或',
  'login.methodsLabel': '登录方式',
  'login.methodPhone': '手机号码',
  'login.methodFacebook': 'Facebook',
  'login.methodGoogle': 'Google',
  'login.methodWeChat': '微信',
  'login.methodSso': 'SSO',
  'login.noAccount': '没有账户？',
  'login.contactUs': '联系我们',
  'login.providerUnavailable': '{provider} 登录暂未开通，请联系 Geeklly 开通。',
  'login.providerInvalidUrl': '{provider} 登录地址配置无效，请联系管理员。',
  'login.passwordRecoveryHint': '请联系 Geeklly 开通或重置账户。',
  'login.errorMissing': '请输入用户名和密码。',
  'login.errorTurnstile': '请先完成人机验证。',
  'login.errorInvalid': '账号或密码错误，请重新输入。',
  'login.turnstileRequired': '请完成人机验证。',
  'login.turnstileComplete': '验证已完成。',
  'login.turnstileExpired': '验证已过期，请重新验证。',
  'login.turnstileLoadFailed': '验证加载失败，请刷新后重试。',
  'login.turnstileUnavailable': '人机验证暂不可用，请联系管理员。',
  'login.heroTitle': '把每次咨询变成可跟进的增长线索',
  'login.heroSubtitle': '帮助中国工厂把海外询盘沉淀为可跟进客户资产。',
  'login.badgeAi': 'AI 助理',
  'login.badgePi': 'PI 雷达',
  'login.badgeWa': 'WA 工作台',
  'login.footer': '全球客户运营企业工作台',
  'login.mockOnline': '全球收件箱在线',
  'login.mockWorkspace': '统一客户工作台',
  'login.mockInbox': '收件箱',
  'login.mockNeedPi': '需要 PI 和目录',
  'login.mockPriceConfirmed': '价格已确认',
  'login.mockFollowup': '2 小时后跟进',
  'login.mockActive': '活跃',
  'login.mockAiAction': 'AI 下一步动作',
  'login.mockReady': '就绪',
  'login.mockAiText': '发送 PI 链接，如果未打开，则安排 6 小时后跟进。',
  'login.mockChannels': '渠道',
  'login.mockConversion': '转化',
  'login.mockQualified': '本周合格回复',
  'nav.home': '主页',
  'nav.dashboard': '数据看板',
  'nav.inquiries': '询盘列表',
  'nav.leadFilter': '线索过滤',
  'nav.customerPool': '客户池',
  'nav.chat': '聊天对话',
  'nav.waBinding': 'WA绑定',
  'nav.piCenter': 'PI成交中心',
  'nav.followupTasks': '跟进任务',
  'nav.marketing': '客户激活',
  'nav.businessReview': '经营复盘',
  'nav.resendSettings': '邮件推送',
  'topbar.notifications': '通知中心',
  'topbar.help': '帮助中心',
  'topbar.online': '在线',
  'profile.view': '查看资料',
  'profile.viewDesc': '管理个人信息',
  'profile.avatar': '更换头像',
  'profile.avatarDesc': '上传新头像',
  'profile.security': '账号安全',
  'profile.securityDesc': '测试阶段本地登录',
  'profile.theme': '界面主题',
  'profile.themeDesc': '个性化界面风格',
  'profile.logout': '退出登录',
  'profile.logoutDesc': '安全退出账户',
  'dashboard.todayData': '今日经营数据',
  'dashboard.settings': '设置',
  'dashboard.chooseCards': '选择显示卡片',
  'dashboard.restoreAll': '恢复全部显示',
  'dashboard.plan': '套餐版本',
  'dashboard.whatsappPrivate': 'WhatsApp 私域',
  'dashboard.validUntil': '有效期',
  'dashboard.dealOpportunities': '今日成交机会',
  'dashboard.dealSubtitle': '根据 PI 打开次数、重复查看、设备与地区行为自动排序。',
  'dashboard.piRadar': 'PI 成交雷达',
  'dashboard.piRadarSubtitle': '把每次打开 PI 转成意向等级和下一步销售动作',
  'dashboard.searchPlaceholder': '搜索客户/产品...',
  'dashboard.newInquiries': '今日新增询盘',
  'dashboard.highIntent': '今日高意向客户',
  'dashboard.sentPi': '今日已发送PI',
  'dashboard.openedPi': '今日已打开PI',
  'dashboard.repeatPi': '重复查看PI客户',
  'dashboard.paymentDue': '待付款金额',
  'dashboard.forecast': '预计成交金额',
  'module.leadFilter.title': '线索过滤',
  'module.leadFilter.subtitle': '把无效询盘、人工复查、AI质量评分和过滤规则集中到一个工作台。所有线索只隐藏、不删除。',
  'module.leadFilter.scanAll': 'AI扫描全部账号线索',
  'module.leadFilter.scanCurrent': 'AI扫描当前WA线索',
  'module.leadFilter.scanning': 'Agent正在扫描...',
  'module.inquiries.title': '询盘列表',
  'module.inquiries.resultCount': '当前筛选结果',
  'module.customerPool.kicker': 'Customer Asset Pool',
  'module.customerPool.title': '客户池',
  'module.customerPool.subtitle': '按 A/B/C/D 层级管理海外客户资产，支持筛选、新增、导入和分配负责人。',
  'module.customerPool.addCustomer': '新增客户',
  'module.customerPool.manualAdd': '手动添加客户',
  'module.customerPool.bulkImport': '批量导入客户',
  'module.customerPool.total': '全部客户',
  'module.customerPool.totalHint': '完整客户资产',
  'module.customerPool.visible': '当前显示',
  'module.customerPool.visibleHint': '当前筛选结果',
  'module.customerPool.tierA': 'A类强成交',
  'module.customerPool.tierAHint': '85-100分 / PI多次打开',
  'module.customerPool.tierB': 'B类重点跟进',
  'module.customerPool.tierBHint': '报价或明确询价',
  'module.customerPool.tierC': 'C类长期培养',
  'module.customerPool.tierCHint': '需求未完全明确',
  'module.customerPool.tierD': 'D类暂缓',
  'module.customerPool.tierDHint': '低价值或沉睡客户',
  'module.customerPool.piOpened': 'PI已打开',
  'module.customerPool.piOpenedHint': '有真实行为',
  'module.customerPool.unassigned': '未分配',
  'module.customerPool.unassignedHint': '需要主账户分配',
  'module.customerPool.filterKeyword': '关键词',
  'module.customerPool.searchPlaceholder': '搜索姓名、WhatsApp、公司、Email',
  'module.customerPool.filterTier': '客户层级',
  'module.customerPool.allTiers': '全部层级',
  'module.customerPool.filterStage': '成交阶段',
  'module.customerPool.allStages': '全部阶段',
  'module.customerPool.filterOwner': '负责人',
  'module.customerPool.allOwners': '全部负责人',
  'module.customerPool.filterCountry': '国家 / 地区',
  'module.customerPool.moreFilters': '更多筛选',
  'module.customerPool.piOpenedFilter': 'PI 是否打开',
  'module.customerPool.all': '全部',
  'module.customerPool.opened': '已打开',
  'module.customerPool.unopened': '未打开',
  'module.customerPool.filterSource': '客户来源',
  'module.customerPool.allSources': '全部来源',
  'module.customerPool.scoreRange': '意向分',
  'module.customerPool.allScores': '全部分数',
  'module.customerPool.sleeping': '沉睡客户',
  'module.customerPool.onlySleeping': '只看沉睡',
  'module.customerPool.excludeSleeping': '排除沉睡',
  'module.customerPool.pendingTask': '未完成任务',
  'module.customerPool.hasTask': '有任务',
  'module.customerPool.noTask': '无任务',
  'module.customerPool.selectedCount': '已选择 {count} 个客户',
  'module.customerPool.chooseOwner': '选择负责人',
  'module.customerPool.assign': '批量分配',
  'module.customerPool.changeTier': '调整层级',
  'module.customerPool.updateTier': '批量改层级',
  'module.customerPool.createTasks': '批量创建任务',
  'module.customerPool.clear': '清空',
  'module.customerPool.scoreUnit': '分',
  'module.customerPool.ownerPrefix': '负责人',
  'module.customerPool.unknownCustomer': '未命名客户',
  'module.customerPool.unknownCountry': '未知国家',
  'module.customerPool.piOpenCount': 'PI 打开 {count} 次',
  'module.customerPool.sourcePrefix': '来源',
  'module.customerPool.needLabel': '需求',
  'module.customerPool.lastMessage': '最近消息',
  'module.customerPool.nextStep': '下一步',
  'module.customerPool.customActionPlaceholder': '输入自定义跟进动作',
  'module.customerPool.createAction': '创建动作',
  'module.customerPool.goChat': '去聊天',
  'module.customerPool.editProfile': '编辑资料',
  'module.customerPool.emptyFiltered': '没有符合筛选条件的客户。',
  'module.chat.selectAccount': '请先选择一个WhatsApp账号以查看对话',
  'module.chat.selectConversation': '选择一个会话开始聊天',
  'module.chat.searchPlaceholder': '搜索客户名/WA号',
  'module.chat.realtimeTranslate': '实时翻译',
  'module.chat.aiAssistant': 'AI助理',
  'module.chat.templates': '产品资料',
  'module.chat.smartPi': '生成智能 PI',
  'module.waBinding.title': 'WA绑定',
  'module.piCenter.title': 'PI成交中心',
  'module.followup.title': '跟进任务',
  'module.marketing.title': '客户激活',
  'module.businessReview.title': '经营复盘',
  'module.resend.title': '邮件推送设置',
  'common.save': '保存',
  'common.cancel': '取消',
  'common.close': '关闭',
  'common.delete': '删除',
  'common.edit': '编辑',
  'common.back': '返回',
  'common.return': '返回',
  'common.search': '搜索',
  'common.export': '导出',
  'common.reset': '重置',
  'common.settings': '设置',
  'common.allCountries': '所有国家',
  'common.allStatuses': '所有状态',
  'common.startDate': '开始日期',
  'common.endDate': '结束日期',
  'common.status': '状态',
  'common.country': '国家',
  'common.customer': '客户',
  'common.product': '产品',
  'common.none': '无',
  'common.noData': '暂无数据',
  'status.precise': '精准线索',
  'status.invalid': '无效线索',
  'status.review': '待审核线索',
  'status.consulting': '咨询中',
  'status.quoted': '已报价',
  'status.piSent': 'PI已发送',
  'status.piOpened': 'PI已查看',
  'status.pendingPayment': '待付款',
  'status.completed': '已成交'
};

const en = {
  'language.label': 'Language',
  'language.current': 'Language',
  'login.brand': 'Geeklly Intelligent Private Traffic CRM',
  'login.logoAlt': 'Geeklly Logo',
  'brand.short': 'Geeklly',
  'brand.system': 'Smart Private CRM',
  'login.title': 'Welcome to log in',
  'login.subtitle': 'Sign in to your Geeklly merchant workspace.',
  'login.account': 'Account',
  'login.password': 'Password',
  'login.accountPlaceholder': 'Email / account / phone number',
  'login.passwordPlaceholder': 'Password',
  'login.keepLoggedIn': 'Keep me logged in',
  'login.forgotPassword': 'Forgot password',
  'login.submit': 'Log in',
  'login.busy': 'Signing in...',
  'login.divider': 'or',
  'login.methodsLabel': 'Login methods',
  'login.methodPhone': 'Phone',
  'login.methodFacebook': 'Facebook',
  'login.methodGoogle': 'Google',
  'login.methodWeChat': 'WeChat',
  'login.methodSso': 'SSO',
  'login.noAccount': 'No account?',
  'login.contactUs': 'Contact us',
  'login.providerUnavailable': '{provider} login is not enabled yet. Contact Geeklly to activate it.',
  'login.providerInvalidUrl': '{provider} login URL is invalid. Contact an administrator.',
  'login.passwordRecoveryHint': 'Contact Geeklly to activate or reset your account.',
  'login.errorMissing': 'Please enter username and password.',
  'login.errorTurnstile': 'Please complete the human verification first.',
  'login.errorInvalid': 'Incorrect account or password. Please try again.',
  'login.turnstileRequired': 'Please complete human verification.',
  'login.turnstileComplete': 'Verification complete.',
  'login.turnstileExpired': 'Verification expired. Please verify again.',
  'login.turnstileLoadFailed': 'Verification failed to load. Please refresh and retry.',
  'login.turnstileUnavailable': 'Human verification is unavailable. Contact an administrator.',
  'login.heroTitle': 'Turn every inquiry into a followable growth lead',
  'login.heroSubtitle': 'Turn overseas inquiries into trackable customer assets for Chinese factories.',
  'login.badgeAi': 'AI Assistant',
  'login.badgePi': 'PI Radar',
  'login.badgeWa': 'WA Workspace',
  'login.footer': 'Enterprise workspace for global customer operations',
  'login.mockOnline': 'Global inbox online',
  'login.mockWorkspace': 'Unified customer workspace',
  'login.mockInbox': 'Inbox',
  'login.mockNeedPi': 'Need PI and catalog',
  'login.mockPriceConfirmed': 'Price confirmed',
  'login.mockFollowup': 'Follow-up in 2h',
  'login.mockActive': 'Active',
  'login.mockAiAction': 'AI next action',
  'login.mockReady': 'Ready',
  'login.mockAiText': 'Send PI link, then schedule a 6-hour follow-up if unopened.',
  'login.mockChannels': 'Channels',
  'login.mockConversion': 'Conversion',
  'login.mockQualified': 'Qualified replies this week',
  'nav.home': 'Home',
  'nav.dashboard': 'Dashboard',
  'nav.inquiries': 'Inquiries',
  'nav.leadFilter': 'Lead Filter',
  'nav.customerPool': 'Customer Pool',
  'nav.chat': 'Chat',
  'nav.waBinding': 'WA Binding',
  'nav.piCenter': 'PI Deal Center',
  'nav.followupTasks': 'Follow-up Tasks',
  'nav.marketing': 'Customer Activation',
  'nav.businessReview': 'Business Review',
  'nav.resendSettings': 'Email Alerts',
  'topbar.notifications': 'Notifications',
  'topbar.help': 'Help Center',
  'topbar.online': 'Online',
  'profile.view': 'View profile',
  'profile.viewDesc': 'Manage personal information',
  'profile.avatar': 'Change avatar',
  'profile.avatarDesc': 'Upload a new avatar',
  'profile.security': 'Account security',
  'profile.securityDesc': 'Local login during testing',
  'profile.theme': 'Interface theme',
  'profile.themeDesc': 'Personalize the interface style',
  'profile.logout': 'Log out',
  'profile.logoutDesc': 'Sign out safely',
  'dashboard.todayData': 'Today’s operating data',
  'dashboard.settings': 'Settings',
  'dashboard.chooseCards': 'Choose visible cards',
  'dashboard.restoreAll': 'Show all cards',
  'dashboard.plan': 'Plan',
  'dashboard.whatsappPrivate': 'WhatsApp Private Domain',
  'dashboard.validUntil': 'Valid until',
  'dashboard.dealOpportunities': 'Today’s deal opportunities',
  'dashboard.dealSubtitle': 'Automatically ranked by PI opens, repeat visits, device, and region behavior.',
  'dashboard.piRadar': 'PI Deal Radar',
  'dashboard.piRadarSubtitle': 'Convert every PI open into intent level and next sales action',
  'dashboard.searchPlaceholder': 'Search customers/products...',
  'dashboard.newInquiries': 'New inquiries today',
  'dashboard.highIntent': 'High-intent customers today',
  'dashboard.sentPi': 'PI sent today',
  'dashboard.openedPi': 'PI opened today',
  'dashboard.repeatPi': 'Repeat PI viewers',
  'dashboard.paymentDue': 'Pending payment',
  'dashboard.forecast': 'Estimated deal value',
  'module.leadFilter.title': 'Lead Filter',
  'module.leadFilter.subtitle': 'Centralize invalid inquiries, manual review, AI quality scores, and filter rules. Leads are hidden, not deleted.',
  'module.leadFilter.scanAll': 'AI scan all account leads',
  'module.leadFilter.scanCurrent': 'AI scan current WA leads',
  'module.leadFilter.scanning': 'Agent scanning...',
  'module.inquiries.title': 'Inquiries',
  'module.inquiries.resultCount': 'Current filtered results',
  'module.customerPool.kicker': 'Customer Asset Pool',
  'module.customerPool.title': 'Customer Pool',
  'module.customerPool.subtitle': 'Manage overseas customer assets by A/B/C/D tier. Filter, add, import, and assign owners.',
  'module.customerPool.addCustomer': 'Add customer',
  'module.customerPool.manualAdd': 'Add manually',
  'module.customerPool.bulkImport': 'Bulk import',
  'module.customerPool.total': 'All customers',
  'module.customerPool.totalHint': 'Complete customer assets',
  'module.customerPool.visible': 'Visible',
  'module.customerPool.visibleHint': 'Current filtered results',
  'module.customerPool.tierA': 'A: Ready to close',
  'module.customerPool.tierAHint': '85-100 / multiple PI opens',
  'module.customerPool.tierB': 'B: Priority follow-up',
  'module.customerPool.tierBHint': 'Quoted or clear inquiry',
  'module.customerPool.tierC': 'C: Nurture',
  'module.customerPool.tierCHint': 'Need is not fully clear',
  'module.customerPool.tierD': 'D: Hold',
  'module.customerPool.tierDHint': 'Low value or dormant',
  'module.customerPool.piOpened': 'PI opened',
  'module.customerPool.piOpenedHint': 'Real engagement',
  'module.customerPool.unassigned': 'Unassigned',
  'module.customerPool.unassignedHint': 'Needs owner assignment',
  'module.customerPool.filterKeyword': 'Keyword',
  'module.customerPool.searchPlaceholder': 'Search name, WhatsApp, company, email',
  'module.customerPool.filterTier': 'Customer tier',
  'module.customerPool.allTiers': 'All tiers',
  'module.customerPool.filterStage': 'Deal stage',
  'module.customerPool.allStages': 'All stages',
  'module.customerPool.filterOwner': 'Owner',
  'module.customerPool.allOwners': 'All owners',
  'module.customerPool.filterCountry': 'Country / region',
  'module.customerPool.moreFilters': 'More filters',
  'module.customerPool.piOpenedFilter': 'PI opened',
  'module.customerPool.all': 'All',
  'module.customerPool.opened': 'Opened',
  'module.customerPool.unopened': 'Not opened',
  'module.customerPool.filterSource': 'Source',
  'module.customerPool.allSources': 'All sources',
  'module.customerPool.scoreRange': 'Intent score',
  'module.customerPool.allScores': 'All scores',
  'module.customerPool.sleeping': 'Dormant customers',
  'module.customerPool.onlySleeping': 'Dormant only',
  'module.customerPool.excludeSleeping': 'Exclude dormant',
  'module.customerPool.pendingTask': 'Open task',
  'module.customerPool.hasTask': 'Has task',
  'module.customerPool.noTask': 'No task',
  'module.customerPool.selectedCount': '{count} customers selected',
  'module.customerPool.chooseOwner': 'Choose owner',
  'module.customerPool.assign': 'Assign',
  'module.customerPool.changeTier': 'Change tier',
  'module.customerPool.updateTier': 'Update tier',
  'module.customerPool.createTasks': 'Create tasks',
  'module.customerPool.clear': 'Clear',
  'module.customerPool.scoreUnit': 'pts',
  'module.customerPool.ownerPrefix': 'Owner',
  'module.customerPool.unknownCustomer': 'Unnamed customer',
  'module.customerPool.unknownCountry': 'Unknown country',
  'module.customerPool.piOpenCount': 'PI opened {count} times',
  'module.customerPool.sourcePrefix': 'Source',
  'module.customerPool.needLabel': 'Need',
  'module.customerPool.lastMessage': 'Last message',
  'module.customerPool.nextStep': 'Next step',
  'module.customerPool.customActionPlaceholder': 'Enter a custom follow-up action',
  'module.customerPool.createAction': 'Create action',
  'module.customerPool.goChat': 'Open chat',
  'module.customerPool.editProfile': 'Edit profile',
  'module.customerPool.emptyFiltered': 'No customers match the current filters.',
  'module.chat.selectAccount': 'Select a WhatsApp account to view conversations',
  'module.chat.selectConversation': 'Select a conversation to start chatting',
  'module.chat.searchPlaceholder': 'Search customer name/WA number',
  'module.chat.realtimeTranslate': 'Realtime translate',
  'module.chat.aiAssistant': 'AI Assistant',
  'module.chat.templates': 'Product Materials',
  'module.chat.smartPi': 'Generate Smart PI',
  'module.waBinding.title': 'WA Binding',
  'module.piCenter.title': 'PI Deal Center',
  'module.followup.title': 'Follow-up Tasks',
  'module.marketing.title': 'Customer Activation',
  'module.businessReview.title': 'Business Review',
  'module.resend.title': 'Email Alert Settings',
  'common.save': 'Save',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.delete': 'Delete',
  'common.edit': 'Edit',
  'common.back': 'Back',
  'common.return': 'Return',
  'common.search': 'Search',
  'common.export': 'Export',
  'common.reset': 'Reset',
  'common.settings': 'Settings',
  'common.allCountries': 'All countries',
  'common.allStatuses': 'All statuses',
  'common.startDate': 'Start date',
  'common.endDate': 'End date',
  'common.status': 'Status',
  'common.country': 'Country',
  'common.customer': 'Customer',
  'common.product': 'Product',
  'common.none': 'None',
  'common.noData': 'No data',
  'status.precise': 'Precise lead',
  'status.invalid': 'Invalid lead',
  'status.review': 'Pending review',
  'status.consulting': 'Consulting',
  'status.quoted': 'Quoted',
  'status.piSent': 'PI sent',
  'status.piOpened': 'PI opened',
  'status.pendingPayment': 'Pending payment',
  'status.completed': 'Completed'
};

const languageOverrides = {
  'zh-Hans': zhHans,
  en,
  'zh-Hant': {
    ...zhHans,
    'language.current': '語言',
    'login.brand': '即客來智能私域獲客系統',
    'brand.short': '即客來',
    'brand.system': '智能私域獲客系統',
    'login.title': '歡迎回來',
    'login.subtitle': '幫助中國工廠把海外詢盤沉澱為可跟進客戶資產。',
    'login.account': '帳號',
    'login.accountPlaceholder': '請輸入帳號',
    'login.passwordPlaceholder': '請輸入密碼',
    'login.submit': '進入系統',
    'login.busy': '登入中...',
    'login.errorMissing': '請輸入使用者名稱和密碼。',
    'login.errorTurnstile': '請先完成人機驗證。',
    'login.errorInvalid': '帳號或密碼錯誤，請重新輸入。',
    'login.heroTitle': '把每次諮詢變成可跟進的增長線索',
    'nav.home': '首頁',
    'nav.dashboard': '數據看板',
    'nav.inquiries': '詢盤列表',
    'nav.leadFilter': '線索過濾',
    'nav.customerPool': '客戶池',
    'nav.chat': '聊天對話',
    'nav.piCenter': 'PI成交中心',
    'nav.followupTasks': '跟進任務',
    'nav.marketing': '客戶激活',
    'nav.businessReview': '經營復盤',
    'nav.resendSettings': '郵件推送',
    'topbar.notifications': '通知中心',
    'topbar.help': '幫助中心',
    'profile.view': '查看資料',
    'profile.viewDesc': '管理個人資訊',
    'profile.avatar': '更換頭像',
    'profile.avatarDesc': '上傳新頭像',
    'profile.logout': '登出',
    'dashboard.todayData': '今日經營數據',
    'dashboard.chooseCards': '選擇顯示卡片',
    'dashboard.restoreAll': '恢復全部顯示',
    'dashboard.plan': '套餐版本',
    'dashboard.validUntil': '有效期',
    'dashboard.dealOpportunities': '今日成交機會',
    'dashboard.piRadar': 'PI 成交雷達',
    'module.leadFilter.title': '線索過濾',
    'module.inquiries.title': '詢盤列表',
    'module.chat.realtimeTranslate': '即時翻譯',
    'common.save': '儲存',
    'common.cancel': '取消',
    'common.close': '關閉',
    'common.delete': '刪除',
    'common.edit': '編輯',
    'common.export': '匯出',
    'common.reset': '重置',
    'status.precise': '精準線索',
    'status.invalid': '無效線索',
    'status.review': '待審核線索'
  },
  es: {
    'language.current': 'Idioma',
    'login.title': 'Bienvenido de nuevo',
    'login.subtitle': 'Convierte consultas internacionales en activos de clientes rastreables.',
    'login.account': 'Cuenta',
    'login.password': 'Contraseña',
    'login.accountPlaceholder': 'Introduce la cuenta',
    'login.passwordPlaceholder': 'Introduce la contraseña',
    'login.submit': 'Entrar al sistema',
    'login.busy': 'Iniciando sesión...',
    'login.heroTitle': 'Convierte cada consulta en una oportunidad de crecimiento',
    'nav.home': 'Inicio',
    'nav.dashboard': 'Panel',
    'nav.inquiries': 'Consultas',
    'nav.leadFilter': 'Filtro de leads',
    'nav.customerPool': 'Clientes',
    'nav.chat': 'Chat',
    'nav.waBinding': 'Conexión WA',
    'nav.piCenter': 'Centro PI',
    'nav.followupTasks': 'Seguimientos',
    'nav.marketing': 'Activación',
    'nav.businessReview': 'Revisión',
    'nav.resendSettings': 'Correos',
    'topbar.notifications': 'Notificaciones',
    'topbar.help': 'Ayuda',
    'profile.logout': 'Cerrar sesión',
    'dashboard.todayData': 'Datos operativos de hoy',
    'dashboard.settings': 'Ajustes',
    'dashboard.dealOpportunities': 'Oportunidades de hoy',
    'dashboard.piRadar': 'Radar PI',
    'module.leadFilter.title': 'Filtro de leads',
    'module.inquiries.title': 'Consultas',
    'module.chat.selectAccount': 'Selecciona una cuenta de WhatsApp para ver conversaciones',
    'module.chat.realtimeTranslate': 'Traducción en tiempo real',
    'common.save': 'Guardar',
    'common.cancel': 'Cancelar',
    'common.close': 'Cerrar',
    'common.delete': 'Eliminar',
    'common.edit': 'Editar',
    'common.search': 'Buscar',
    'common.export': 'Exportar',
    'common.reset': 'Restablecer',
    'common.allCountries': 'Todos los países',
    'common.allStatuses': 'Todos los estados',
    'status.precise': 'Lead preciso',
    'status.invalid': 'Lead inválido',
    'status.review': 'Pendiente de revisión'
  },
  pt: {
    'language.current': 'Idioma',
    'login.title': 'Bem-vindo de volta',
    'login.subtitle': 'Transforme consultas internacionais em ativos de clientes rastreáveis.',
    'login.account': 'Conta',
    'login.password': 'Senha',
    'login.accountPlaceholder': 'Digite a conta',
    'login.passwordPlaceholder': 'Digite a senha',
    'login.submit': 'Entrar no sistema',
    'login.busy': 'Entrando...',
    'login.heroTitle': 'Transforme cada consulta em um lead de crescimento',
    'nav.home': 'Início',
    'nav.dashboard': 'Painel',
    'nav.inquiries': 'Consultas',
    'nav.leadFilter': 'Filtro de leads',
    'nav.customerPool': 'Clientes',
    'nav.chat': 'Chat',
    'nav.waBinding': 'Conexão WA',
    'nav.piCenter': 'Centro PI',
    'nav.followupTasks': 'Tarefas',
    'nav.marketing': 'Ativação',
    'nav.businessReview': 'Revisão',
    'nav.resendSettings': 'E-mails',
    'topbar.notifications': 'Notificações',
    'topbar.help': 'Ajuda',
    'profile.logout': 'Sair',
    'dashboard.todayData': 'Dados operacionais de hoje',
    'dashboard.dealOpportunities': 'Oportunidades de hoje',
    'dashboard.piRadar': 'Radar PI',
    'module.leadFilter.title': 'Filtro de leads',
    'module.inquiries.title': 'Consultas',
    'module.chat.realtimeTranslate': 'Tradução em tempo real',
    'common.save': 'Salvar',
    'common.cancel': 'Cancelar',
    'common.close': 'Fechar',
    'common.delete': 'Excluir',
    'common.edit': 'Editar',
    'common.search': 'Pesquisar',
    'common.export': 'Exportar',
    'common.reset': 'Redefinir',
    'status.precise': 'Lead preciso',
    'status.invalid': 'Lead inválido',
    'status.review': 'Em revisão'
  },
  fr: {
    'language.current': 'Langue',
    'login.title': 'Bon retour',
    'login.subtitle': 'Transformez les demandes internationales en actifs clients suivables.',
    'login.account': 'Compte',
    'login.password': 'Mot de passe',
    'login.accountPlaceholder': 'Saisir le compte',
    'login.passwordPlaceholder': 'Saisir le mot de passe',
    'login.submit': 'Entrer dans le système',
    'login.busy': 'Connexion...',
    'login.heroTitle': 'Transformez chaque demande en piste de croissance',
    'nav.home': 'Accueil',
    'nav.dashboard': 'Tableau de bord',
    'nav.inquiries': 'Demandes',
    'nav.leadFilter': 'Filtre de leads',
    'nav.customerPool': 'Clients',
    'nav.chat': 'Chat',
    'nav.waBinding': 'Connexion WA',
    'nav.piCenter': 'Centre PI',
    'nav.followupTasks': 'Suivis',
    'nav.marketing': 'Activation',
    'nav.businessReview': 'Revue',
    'nav.resendSettings': 'E-mails',
    'topbar.notifications': 'Notifications',
    'topbar.help': 'Aide',
    'profile.logout': 'Déconnexion',
    'dashboard.todayData': 'Données du jour',
    'dashboard.dealOpportunities': 'Opportunités du jour',
    'dashboard.piRadar': 'Radar PI',
    'module.leadFilter.title': 'Filtre de leads',
    'module.inquiries.title': 'Demandes',
    'module.chat.realtimeTranslate': 'Traduction en direct',
    'common.save': 'Enregistrer',
    'common.cancel': 'Annuler',
    'common.close': 'Fermer',
    'common.delete': 'Supprimer',
    'common.edit': 'Modifier',
    'common.search': 'Rechercher',
    'common.export': 'Exporter',
    'common.reset': 'Réinitialiser',
    'status.precise': 'Lead qualifié',
    'status.invalid': 'Lead invalide',
    'status.review': 'En révision'
  },
  de: {
    'language.current': 'Sprache',
    'login.title': 'Willkommen zurück',
    'login.subtitle': 'Machen Sie internationale Anfragen zu nachverfolgbaren Kundenwerten.',
    'login.account': 'Konto',
    'login.password': 'Passwort',
    'login.accountPlaceholder': 'Konto eingeben',
    'login.passwordPlaceholder': 'Passwort eingeben',
    'login.submit': 'System öffnen',
    'login.busy': 'Anmeldung...',
    'login.heroTitle': 'Jede Anfrage wird zu einem verfolgbaren Wachstumslead',
    'nav.home': 'Start',
    'nav.dashboard': 'Dashboard',
    'nav.inquiries': 'Anfragen',
    'nav.leadFilter': 'Lead-Filter',
    'nav.customerPool': 'Kundenpool',
    'nav.chat': 'Chat',
    'nav.waBinding': 'WA-Verbindung',
    'nav.piCenter': 'PI-Zentrum',
    'nav.followupTasks': 'Follow-ups',
    'nav.marketing': 'Aktivierung',
    'nav.businessReview': 'Geschäftsreview',
    'nav.resendSettings': 'E-Mail',
    'common.save': 'Speichern',
    'common.cancel': 'Abbrechen',
    'common.close': 'Schließen',
    'common.delete': 'Löschen',
    'common.edit': 'Bearbeiten',
    'common.search': 'Suchen',
    'common.export': 'Exportieren',
    'common.reset': 'Zurücksetzen'
  },
  it: {
    'language.current': 'Lingua',
    'login.title': 'Bentornato',
    'login.account': 'Account',
    'login.password': 'Password',
    'login.submit': 'Entra nel sistema',
    'login.busy': 'Accesso...',
    'login.heroTitle': 'Trasforma ogni richiesta in un lead di crescita',
    'nav.home': 'Home',
    'nav.dashboard': 'Dashboard',
    'nav.inquiries': 'Richieste',
    'nav.leadFilter': 'Filtro lead',
    'nav.customerPool': 'Clienti',
    'nav.chat': 'Chat',
    'nav.waBinding': 'WA Binding',
    'nav.piCenter': 'Centro PI',
    'nav.followupTasks': 'Follow-up',
    'nav.marketing': 'Attivazione',
    'nav.businessReview': 'Revisione',
    'nav.resendSettings': 'Email',
    'common.save': 'Salva',
    'common.cancel': 'Annulla',
    'common.close': 'Chiudi',
    'common.search': 'Cerca'
  },
  ru: {
    'language.current': 'Язык',
    'login.title': 'С возвращением',
    'login.account': 'Аккаунт',
    'login.password': 'Пароль',
    'login.submit': 'Войти в систему',
    'login.busy': 'Вход...',
    'login.heroTitle': 'Превращайте каждый запрос в отслеживаемый лид',
    'nav.home': 'Главная',
    'nav.dashboard': 'Панель',
    'nav.inquiries': 'Запросы',
    'nav.leadFilter': 'Фильтр лидов',
    'nav.customerPool': 'Клиенты',
    'nav.chat': 'Чат',
    'nav.waBinding': 'WA привязка',
    'nav.piCenter': 'PI центр',
    'nav.followupTasks': 'Задачи',
    'nav.marketing': 'Активация',
    'nav.businessReview': 'Обзор',
    'nav.resendSettings': 'Почта',
    'common.save': 'Сохранить',
    'common.cancel': 'Отмена',
    'common.close': 'Закрыть',
    'common.search': 'Поиск'
  },
  ja: {
    'language.current': '言語',
    'login.title': 'おかえりなさい',
    'login.account': 'アカウント',
    'login.password': 'パスワード',
    'login.submit': 'システムへ入る',
    'login.busy': 'ログイン中...',
    'login.heroTitle': 'すべての問い合わせを追跡可能な成長リードへ',
    'nav.home': 'ホーム',
    'nav.dashboard': 'ダッシュボード',
    'nav.inquiries': '問い合わせ',
    'nav.leadFilter': 'リードフィルター',
    'nav.customerPool': '顧客プール',
    'nav.chat': 'チャット',
    'nav.waBinding': 'WA連携',
    'nav.piCenter': 'PIセンター',
    'nav.followupTasks': 'フォローアップ',
    'nav.marketing': '顧客活性化',
    'nav.businessReview': '事業レビュー',
    'nav.resendSettings': 'メール',
    'common.save': '保存',
    'common.cancel': 'キャンセル',
    'common.close': '閉じる',
    'common.search': '検索'
  },
  ko: {
    'language.current': '언어',
    'login.title': '다시 오신 것을 환영합니다',
    'login.account': '계정',
    'login.password': '비밀번호',
    'login.submit': '시스템 입장',
    'login.busy': '로그인 중...',
    'login.heroTitle': '모든 문의를 추적 가능한 성장 리드로 전환',
    'nav.home': '홈',
    'nav.dashboard': '대시보드',
    'nav.inquiries': '문의',
    'nav.leadFilter': '리드 필터',
    'nav.customerPool': '고객 풀',
    'nav.chat': '채팅',
    'nav.waBinding': 'WA 연결',
    'nav.piCenter': 'PI 센터',
    'nav.followupTasks': '후속 작업',
    'nav.marketing': '고객 활성화',
    'nav.businessReview': '비즈니스 리뷰',
    'nav.resendSettings': '이메일',
    'common.save': '저장',
    'common.cancel': '취소',
    'common.close': '닫기',
    'common.search': '검색'
  },
  th: {
    'language.current': 'ภาษา',
    'login.title': 'ยินดีต้อนรับกลับ',
    'login.account': 'บัญชี',
    'login.password': 'รหัสผ่าน',
    'login.submit': 'เข้าสู่ระบบ',
    'login.busy': 'กำลังเข้าสู่ระบบ...',
    'login.heroTitle': 'เปลี่ยนทุกคำถามให้เป็นลีดที่ติดตามได้',
    'nav.home': 'หน้าแรก',
    'nav.dashboard': 'แดชบอร์ด',
    'nav.inquiries': 'คำถาม',
    'nav.leadFilter': 'กรองลีด',
    'nav.customerPool': 'ลูกค้า',
    'nav.chat': 'แชท',
    'nav.waBinding': 'เชื่อม WA',
    'nav.piCenter': 'ศูนย์ PI',
    'nav.followupTasks': 'ติดตาม',
    'nav.marketing': 'กระตุ้นลูกค้า',
    'nav.businessReview': 'รีวิวธุรกิจ',
    'nav.resendSettings': 'อีเมล',
    'common.save': 'บันทึก',
    'common.cancel': 'ยกเลิก',
    'common.close': 'ปิด',
    'common.search': 'ค้นหา'
  },
  id: {
    'language.current': 'Bahasa',
    'login.title': 'Selamat datang kembali',
    'login.account': 'Akun',
    'login.password': 'Kata sandi',
    'login.submit': 'Masuk sistem',
    'login.busy': 'Masuk...',
    'login.heroTitle': 'Ubah setiap pertanyaan menjadi prospek yang dapat ditindaklanjuti',
    'nav.home': 'Beranda',
    'nav.dashboard': 'Dasbor',
    'nav.inquiries': 'Pertanyaan',
    'nav.leadFilter': 'Filter Lead',
    'nav.customerPool': 'Pelanggan',
    'nav.chat': 'Chat',
    'nav.waBinding': 'WA Binding',
    'nav.piCenter': 'Pusat PI',
    'nav.followupTasks': 'Tindak lanjut',
    'nav.marketing': 'Aktivasi',
    'nav.businessReview': 'Review Bisnis',
    'nav.resendSettings': 'Email',
    'common.save': 'Simpan',
    'common.cancel': 'Batal',
    'common.close': 'Tutup',
    'common.search': 'Cari'
  },
  tr: {
    'language.current': 'Dil',
    'login.title': 'Tekrar hoş geldiniz',
    'login.account': 'Hesap',
    'login.password': 'Şifre',
    'login.submit': 'Sisteme gir',
    'login.busy': 'Giriş yapılıyor...',
    'login.heroTitle': 'Her sorguyu takip edilebilir büyüme potansiyeline dönüştürün',
    'nav.home': 'Ana sayfa',
    'nav.dashboard': 'Panel',
    'nav.inquiries': 'Sorgular',
    'nav.leadFilter': 'Lead filtresi',
    'nav.customerPool': 'Müşteriler',
    'nav.chat': 'Sohbet',
    'nav.waBinding': 'WA bağlantısı',
    'nav.piCenter': 'PI merkezi',
    'nav.followupTasks': 'Takipler',
    'nav.marketing': 'Aktivasyon',
    'nav.businessReview': 'İş değerlendirme',
    'nav.resendSettings': 'E-posta',
    'common.save': 'Kaydet',
    'common.cancel': 'İptal',
    'common.close': 'Kapat',
    'common.search': 'Ara'
  },
  vi: {
    'language.current': 'Ngôn ngữ',
    'login.title': 'Chào mừng trở lại',
    'login.account': 'Tài khoản',
    'login.password': 'Mật khẩu',
    'login.submit': 'Vào hệ thống',
    'login.busy': 'Đang đăng nhập...',
    'login.heroTitle': 'Biến mọi yêu cầu thành khách hàng tiềm năng có thể theo dõi',
    'nav.home': 'Trang chủ',
    'nav.dashboard': 'Bảng điều khiển',
    'nav.inquiries': 'Yêu cầu',
    'nav.leadFilter': 'Lọc lead',
    'nav.customerPool': 'Khách hàng',
    'nav.chat': 'Trò chuyện',
    'nav.waBinding': 'Kết nối WA',
    'nav.piCenter': 'Trung tâm PI',
    'nav.followupTasks': 'Theo dõi',
    'nav.marketing': 'Kích hoạt',
    'nav.businessReview': 'Đánh giá',
    'nav.resendSettings': 'Email',
    'common.save': 'Lưu',
    'common.cancel': 'Hủy',
    'common.close': 'Đóng',
    'common.search': 'Tìm kiếm'
  },
  ar: {
    'language.current': 'اللغة',
    'login.title': 'مرحباً بعودتك',
    'login.account': 'الحساب',
    'login.password': 'كلمة المرور',
    'login.submit': 'دخول النظام',
    'login.busy': 'جارٍ تسجيل الدخول...',
    'login.heroTitle': 'حوّل كل استفسار إلى فرصة نمو قابلة للمتابعة',
    'nav.home': 'الرئيسية',
    'nav.dashboard': 'لوحة البيانات',
    'nav.inquiries': 'الاستفسارات',
    'nav.leadFilter': 'فلتر العملاء',
    'nav.customerPool': 'مجموعة العملاء',
    'nav.chat': 'الدردشة',
    'nav.waBinding': 'ربط واتساب',
    'nav.piCenter': 'مركز PI',
    'nav.followupTasks': 'مهام المتابعة',
    'nav.marketing': 'تنشيط العملاء',
    'nav.businessReview': 'مراجعة الأعمال',
    'nav.resendSettings': 'البريد',
    'common.save': 'حفظ',
    'common.cancel': 'إلغاء',
    'common.close': 'إغلاق',
    'common.search': 'بحث'
  },
  he: {
    'language.current': 'שפה',
    'login.title': 'ברוך שובך',
    'login.account': 'חשבון',
    'login.password': 'סיסמה',
    'login.submit': 'כניסה למערכת',
    'login.busy': 'מתחבר...',
    'login.heroTitle': 'הפוך כל פנייה לליד צמיחה שניתן לעקוב אחריו',
    'nav.home': 'בית',
    'nav.dashboard': 'לוח בקרה',
    'nav.inquiries': 'פניות',
    'nav.leadFilter': 'סינון לידים',
    'nav.customerPool': 'לקוחות',
    'nav.chat': 'צ׳אט',
    'nav.waBinding': 'חיבור WA',
    'nav.piCenter': 'מרכז PI',
    'nav.followupTasks': 'מעקבים',
    'nav.marketing': 'הפעלה',
    'nav.businessReview': 'סקירה עסקית',
    'nav.resendSettings': 'אימייל',
    'common.save': 'שמור',
    'common.cancel': 'ביטול',
    'common.close': 'סגור',
    'common.search': 'חיפוש'
  },
  my: {
    'language.current': 'ဘာသာစကား',
    'login.title': 'ပြန်လည်ကြိုဆိုပါသည်',
    'login.account': 'အကောင့်',
    'login.password': 'စကားဝှက်',
    'login.submit': 'စနစ်ထဲဝင်ရန်',
    'login.busy': 'ဝင်နေသည်...',
    'login.heroTitle': 'မေးမြန်းချက်တိုင်းကို လိုက်နာနိုင်သော lead အဖြစ်ပြောင်းပါ',
    'nav.home': 'မူလ',
    'nav.dashboard': 'ဒက်ရှ်ဘုတ်',
    'nav.inquiries': 'မေးမြန်းချက်များ',
    'nav.leadFilter': 'Lead စစ်ထုတ်',
    'nav.customerPool': 'ဖောက်သည်များ',
    'nav.chat': 'ချက်',
    'nav.waBinding': 'WA ချိတ်ဆက်မှု',
    'nav.piCenter': 'PI စင်တာ',
    'nav.followupTasks': 'နောက်ဆက်တွဲ',
    'nav.marketing': 'ဖောက်သည်လှုံ့ဆော်မှု',
    'nav.businessReview': 'လုပ်ငန်းပြန်လည်သုံးသပ်မှု',
    'nav.resendSettings': 'အီးမေးလ်',
    'common.save': 'သိမ်း',
    'common.cancel': 'မလုပ်တော့',
    'common.close': 'ပိတ်',
    'common.search': 'ရှာရန်'
  }
};

export const UI_I18N_MESSAGES = Object.freeze(
  Object.fromEntries(
    SUPPORTED_UI_LANGUAGES.map(({ code }) => [code, Object.freeze({ ...en, ...(languageOverrides[code] || {}) })])
  )
);

const sourceTextToKey = new Map();

function registerSourceText(source, key) {
  if (!source || !key || sourceTextToKey.has(source)) return;
  sourceTextToKey.set(source, key);
}

for (const [key, value] of Object.entries(zhHans)) {
  registerSourceText(value, key);
}

for (const [key, value] of Object.entries(en)) {
  registerSourceText(value, key);
}

const explicitSources = {
  '即客来 Geeklly': 'brand.short',
  'Unified customer workspace': 'login.mockWorkspace',
  'Global inbox online': 'login.mockOnline',
  'Inbox': 'login.mockInbox',
  'Need PI and catalog': 'login.mockNeedPi',
  'Price confirmed': 'login.mockPriceConfirmed',
  'Follow-up in 2h': 'login.mockFollowup',
  'Active': 'login.mockActive',
  'AI next action': 'login.mockAiAction',
  'Ready': 'login.mockReady',
  'Send PI link, then schedule a 6-hour follow-up if unopened.': 'login.mockAiText',
  'Channels': 'login.mockChannels',
  'Conversion': 'login.mockConversion',
  'Qualified replies this week': 'login.mockQualified',
  'Enterprise workspace for global customer operations': 'login.footer'
};

for (const [source, key] of Object.entries(explicitSources)) {
  registerSourceText(source, key);
}

function getLanguageMeta(code) {
  return SUPPORTED_UI_LANGUAGES.find((language) => language.code === code) || SUPPORTED_UI_LANGUAGES.find((language) => language.code === 'zh-Hans');
}

export function normalizeUiLanguageCode(value = '') {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const lower = raw.replace('_', '-').toLowerCase();
  if (lower === 'zh' || lower === 'zh-cn' || lower === 'zh-sg' || lower === 'zh-hans') return 'zh-Hans';
  if (lower === 'zh-tw' || lower === 'zh-hk' || lower === 'zh-mo' || lower === 'zh-hant') return 'zh-Hant';
  if (lower === 'iw') return 'he';
  if (lower === 'mm' || lower === 'my-mm' || lower === 'burmese') return 'my';
  const base = lower.split('-')[0];
  return SUPPORTED_UI_LANGUAGES.some((language) => language.code === base) ? base : '';
}

function getInitialLanguage(win) {
  try {
    const saved = normalizeUiLanguageCode(win.localStorage?.getItem(UI_LANGUAGE_STORAGE_KEY));
    if (saved) return saved;
  } catch (error) {}

  const candidates = [
    ...(Array.isArray(win.navigator?.languages) ? win.navigator.languages : []),
    win.navigator?.language,
    win.navigator?.userLanguage
  ].filter(Boolean);

  for (const candidate of candidates) {
    const normalized = normalizeUiLanguageCode(candidate);
    if (normalized) return normalized;
  }

  return 'zh-Hans';
}

function interpolate(template = '', values = {}) {
  return String(template).replace(/\{(\w+)\}/g, (match, key) => {
    return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
  });
}

function installGeekllyI18n(win) {
  if (!win || win.GeekllyI18n?.__installed) return win?.GeekllyI18n;

  let currentLanguage = getInitialLanguage(win);
  let observer = null;
  let observerTimer = null;

  const api = {
    __installed: true,
    languages: SUPPORTED_UI_LANGUAGES,
    requiredKeys: REQUIRED_UI_I18N_KEYS,
    messages: UI_I18N_MESSAGES,
    normalize: normalizeUiLanguageCode,
    getLanguage() {
      return currentLanguage;
    },
    getLanguageMeta(code = currentLanguage) {
      return getLanguageMeta(code);
    },
    t(keyOrSource, values = {}) {
      const key = UI_I18N_MESSAGES[currentLanguage]?.[keyOrSource] ? keyOrSource : sourceTextToKey.get(String(keyOrSource));
      const template = key ? (UI_I18N_MESSAGES[currentLanguage]?.[key] || UI_I18N_MESSAGES.en?.[key] || zhHans[key] || keyOrSource) : keyOrSource;
      return interpolate(template, values);
    },
    setLanguage(code, options = {}) {
      const normalized = normalizeUiLanguageCode(code) || 'zh-Hans';
      if (!UI_I18N_MESSAGES[normalized]) return currentLanguage;
      currentLanguage = normalized;
      try {
        win.localStorage?.setItem(UI_LANGUAGE_STORAGE_KEY, normalized);
      } catch (error) {}
      applyDocumentLanguage();
      renderAllSwitchers();
      api.localizeDom(win.document);
      win.dispatchEvent(new CustomEvent('geeklly:languagechange', { detail: { language: normalized } }));
      if (options.rerender && typeof win.navigateTo === 'function') {
        win.navigateTo(win.location.hash || '#dashboard');
      }
      return currentLanguage;
    },
    renderLanguageSwitcher(target, options = {}) {
      const root = typeof target === 'string' ? win.document.querySelector(target) : target;
      if (!root) return null;
      root.classList.add('geeklly-ui-language-switcher');
      root.dataset.variant = options.variant || root.dataset.variant || 'default';
      root.innerHTML = renderSwitcherMarkup(root.dataset.variant);
      return root;
    },
    localizeDom(root = win.document) {
      if (!root) return;
      const rootElement = root.nodeType === 1 ? root : root.documentElement;
      if (!rootElement) return;

      localizeExplicitElements(rootElement);
      localizeExactElements(rootElement);
      localizeAttributes(rootElement);
      renderAllSwitchers();
    },
    startAutoLocalization() {
      if (observer || !win.MutationObserver || !win.document?.body) return;
      observer = new win.MutationObserver((mutations) => {
        if (!mutations.some((mutation) => mutation.type === 'childList' || mutation.type === 'characterData' || mutation.type === 'attributes')) return;
        win.clearTimeout(observerTimer);
        observerTimer = win.setTimeout(() => api.localizeDom(win.document), 50);
      });
      observer.observe(win.document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['placeholder', 'title', 'aria-label', 'alt']
      });
    }
  };

  function applyDocumentLanguage() {
    const meta = getLanguageMeta(currentLanguage);
    win.document?.documentElement?.setAttribute('lang', currentLanguage);
    win.document?.documentElement?.setAttribute('dir', meta.dir || 'ltr');
    win.document?.body?.classList.toggle('geeklly-ui-rtl', meta.dir === 'rtl');
  }

  function renderSwitcherMarkup(variant = 'default') {
    const meta = getLanguageMeta(currentLanguage);
    const optionsHtml = SUPPORTED_UI_LANGUAGES.map((language) => `
      <button type="button" class="geeklly-ui-language-option ${language.code === currentLanguage ? 'is-active' : ''}" data-ui-language-option="${language.code}" role="option" aria-selected="${language.code === currentLanguage ? 'true' : 'false'}">
        <span class="geeklly-ui-language-flag">${language.flag}</span>
        <span class="geeklly-ui-language-name">${language.nativeName}</span>
      </button>
    `).join('');

    return `
      <button type="button" class="geeklly-ui-language-button" data-ui-language-toggle aria-haspopup="listbox" aria-expanded="false" aria-label="${api.t('language.current')}: ${meta.label}" title="${api.t('language.current')}: ${meta.label}">
        <span class="geeklly-ui-language-flag">${meta.flag}</span>
        <span class="geeklly-ui-language-button-text">${meta.shortLabel || meta.code.toUpperCase()}</span>
        <span class="geeklly-ui-language-chevron" aria-hidden="true"></span>
      </button>
      <div class="geeklly-ui-language-menu" data-ui-language-menu role="listbox" aria-label="${api.t('language.current')}">
        ${optionsHtml}
      </div>
    `;
  }

  function renderAllSwitchers() {
    const roots = win.document?.querySelectorAll?.('.geeklly-ui-language-switcher') || [];
    roots.forEach((root) => {
      if (root.dataset.renderingLanguage === currentLanguage && root.querySelector('[data-ui-language-toggle]')) return;
      root.dataset.renderingLanguage = currentLanguage;
      const variant = root.dataset.variant || 'default';
      root.innerHTML = renderSwitcherMarkup(variant);
    });
  }

  function localizeExplicitElements(rootElement) {
    rootElement.querySelectorAll?.('[data-i18n]').forEach((element) => {
      element.textContent = api.t(element.dataset.i18n);
    });
  }

  function localizeExactElements(rootElement) {
    const elements = [rootElement, ...rootElement.querySelectorAll?.('button, a, span, p, h1, h2, h3, h4, label, strong, small, div, option') || []];
    elements.forEach((element) => {
      if (!(element instanceof win.HTMLElement)) return;
      if (element.closest('.geeklly-ui-language-switcher')) return;
      if (['SCRIPT', 'STYLE', 'SVG', 'IMG', 'INPUT', 'TEXTAREA', 'SELECT'].includes(element.tagName)) return;
      if (element.children.length > 0) return;
      const currentText = element.textContent || '';
      const trimmed = currentText.trim();
      if (!trimmed) return;
      const source = element.dataset.i18nSource || (sourceTextToKey.has(trimmed) ? trimmed : '');
      if (!source) return;
      const key = sourceTextToKey.get(source);
      if (!key) return;
      element.dataset.i18nSource = source;
      const translated = api.t(key);
      element.textContent = currentText.replace(trimmed, translated);
    });
  }

  function localizeAttributes(rootElement) {
    const attrs = [
      ['data-i18n-placeholder', 'placeholder'],
      ['data-i18n-title', 'title'],
      ['data-i18n-aria-label', 'aria-label'],
      ['data-i18n-alt', 'alt']
    ];
    attrs.forEach(([dataAttr, attr]) => {
      rootElement.querySelectorAll?.(`[${dataAttr}]`).forEach((element) => {
        element.setAttribute(attr, api.t(element.getAttribute(dataAttr)));
      });
    });

    rootElement.querySelectorAll?.('[placeholder], [title], [aria-label], [alt]').forEach((element) => {
      if (element.closest('.geeklly-ui-language-switcher')) return;
      ['placeholder', 'title', 'aria-label', 'alt'].forEach((attr) => {
        if (!element.hasAttribute(attr)) return;
        const dataKey = `i18nSource${attr.replace(/(^|-)(\w)/g, (_, _dash, char) => char.toUpperCase())}`;
        const current = element.getAttribute(attr) || '';
        const source = element.dataset[dataKey] || (sourceTextToKey.has(current) ? current : '');
        if (!source) return;
        const key = sourceTextToKey.get(source);
        if (!key) return;
        element.dataset[dataKey] = source;
        element.setAttribute(attr, api.t(key));
      });
    });
  }

  win.document?.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    const toggle = target?.closest?.('[data-ui-language-toggle]');
    if (toggle) {
      event.preventDefault();
      const switcher = toggle.closest('.geeklly-ui-language-switcher');
      const isOpen = switcher?.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      return;
    }

    const option = target?.closest?.('[data-ui-language-option]');
    if (option) {
      event.preventDefault();
      const code = option.getAttribute('data-ui-language-option');
      option.closest('.geeklly-ui-language-switcher')?.classList.remove('is-open');
      api.setLanguage(code, { rerender: true });
      return;
    }

    if (!target?.closest?.('.geeklly-ui-language-switcher')) {
      win.document.querySelectorAll('.geeklly-ui-language-switcher.is-open').forEach((switcher) => {
        switcher.classList.remove('is-open');
        switcher.querySelector('[data-ui-language-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    }
  });

  win.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    win.document.querySelectorAll('.geeklly-ui-language-switcher.is-open').forEach((switcher) => {
      switcher.classList.remove('is-open');
      switcher.querySelector('[data-ui-language-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  });

  win.GeekllyI18n = api;
  applyDocumentLanguage();
  return api;
}

if (typeof window !== 'undefined') {
  installGeekllyI18n(window);
}

export { installGeekllyI18n };
